export default __webpack_public_path__ + "static/1838-776d712bb3cd600fc4d8241bf05f0075.gif";